import React, { useRef, useState } from 'react'; 
import { Button, Modal, Badge, Tooltip, OverlayTrigger , Form } from 'react-bootstrap';


const ViewDailyOrders = ({ show, onClose, data }) => {
  const tableRef = useRef(null);

  const formatDate = (dateStr) => {
    if (!dateStr) return "--";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  // Show checkboxes only after clicking Print
  const [showCheckboxes, setShowCheckboxes] = useState(false);

  // State for checkboxes
  const [printOptions, setPrintOptions] = useState({
    header: true, // single checkbox for header section
    rawMaterials: data?.raw_materials?.map(() => true) || [],
  });

  const toggleHeader = () => {
    setPrintOptions(prev => ({ ...prev, header: !prev.header }));
  };

  const toggleRawMaterial = (index) => {
    const newRM = [...printOptions.rawMaterials];
    newRM[index] = !newRM[index];
    setPrintOptions(prev => ({ ...prev, rawMaterials: newRM }));
  };

  const handlePrintClick = () => {
    setShowCheckboxes(true);
  };

  const handlePrint = () => {
    // Ensure at least one selection
    if (!printOptions.header && !printOptions.rawMaterials.some(r => r)) {
      alert("Please select at least one item to print");
      return;
    }

    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Print</title></head><body>');

    // Header
    const headerLabels = ["Date", "Item Name", "Master Name", "Cooking Qty"];
    const headerValues = [
      formatDate(data?.dailyorder_date),
      data?.item_name || '--',
      data?.master_name || '--',
      `${data?.order_quantity} ${data?.order_unit}`
    ];

    if (printOptions.header) {
      printWindow.document.write('<div>');
      headerLabels.forEach((label, i) => {
        printWindow.document.write(`<p><strong>${label}:</strong> ${headerValues[i]}</p>`);
      });
      printWindow.document.write('<hr/></div>');
    }

    // Raw Materials
    printWindow.document.write('<table border="1" style="border-collapse: collapse; width: 100%;">');
    printWindow.document.write('<tr><th>Raw Material</th><th>Quantity</th></tr>');
    data?.raw_materials?.forEach((rm, i) => {
      if (printOptions.rawMaterials[i]) {
        printWindow.document.write(`
          <tr>
            <td>${rm.raw_material_name}</td>
            <td>${rm.quantity} ${rm.label_unit}</td>
          </tr>
        `);
      }
    });
    printWindow.document.write('</table>');

    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <Modal show={show} size="lg">
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">View Daily Orders</h3>
          <Button variant="" type="button" className="close px-6 py-1" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">

          {/* HEADER SECTION */}
          <div className="mb-3 d-flex justify-content-between align-items-start flex-wrap">
            <div className="d-flex flex-column me-4">
              <label className="fs-7 text-black mb-0 font-w500">Date</label>
              <span className="fs-6 text-danger mb-0 font-w500">{formatDate(data?.dailyorder_date)}</span>
            </div>

            <div className="d-flex flex-column me-4">
              <label className="fs-7 text-black mb-0 font-w500">Item Name</label>
              <span className="fs-7 text-black mb-0">{data?.item_name || '--'}</span>
            </div>

            <div className="d-flex flex-column me-4">
              <label className="fs-7 text-black mb-0 font-w500">Master Name</label>
              <span className="fs-7 text-black mb-0">{data?.master_name || '--'}</span>
            </div>

            <div className="d-flex flex-column me-4">
              <label className="fs-7 text-black mb-0 font-w500">Cooking Qty</label>
              <Badge bg="badge-circle" className='badge-outline-danger fw-bold fs-6'>
                {data?.order_quantity} {data?.order_unit}
              </Badge>
            </div>

            {/* Print Button */}
            <div className='text-black fw-bold'>
              {!showCheckboxes ? (
                <Button variant="light" onClick={handlePrintClick}>
                  Print
                </Button>
              ) : (
                <Form.Check
                  type="checkbox"
                  checked={printOptions.header}
                  onChange={toggleHeader}
                  label="Include Header Section"
                  className="mt-2"
                />
              )}
            </div>
          </div>

          {/* RAW MATERIAL TABLE */}
            <div className="table-container">
          <table  className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
           
            <thead>
                <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                    {showCheckboxes && <th>Print?</th>}
                    <th className='min-w-100px text-start'>Raw Material</th>
                    <th className='min-w-100px text-center'>Required Qty</th>
                </tr>
            </thead>
            <tbody className="text-gray-600 fw-semibold fs-7">
              {data?.raw_materials?.map((rm, i) => (
                <tr key={i}>
                  {showCheckboxes && (
                    <td>
                      <Form.Check
                        type="checkbox"
                        checked={printOptions.rawMaterials[i]}
                        onChange={() => toggleRawMaterial(i)}
                      />
                    </td>
                  )}
                  <td>
                    <label className='text-black font-w400 fs-7'>
                        {rm.raw_material_name}
                    </label>
                </td>
                 <td className='text-center'>
                    <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement="bottom"
                        overlay={
                            <Tooltip className='toltip-popover'>
                                <span className='fs-8 text-white fw-semibold'>
                                    Required quantity for cooking
                                </span>
                            </Tooltip>
                        }
                    >
                        <Badge bg="none" className='border text-primary border-primary font-w400 fs-7 px-1 py-0'>
                            {rm.quantity} {rm.label_unit}
                        </Badge>
                    </OverlayTrigger>
                </td>
                </tr>
              ))}
            </tbody>
          </table>
              </div>
          {/* Print Button for final print */}
          {showCheckboxes && (
            <div className="mt-3">
              <Button variant="success" onClick={handlePrint}>
                Print Selected
              </Button>
            </div>
          )}

        </div>
      </div>
    </Modal>
  );
};

export default ViewDailyOrders;
